import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  appTrackingUrl = new BehaviorSubject("");
  private popupStateSource = new BehaviorSubject<boolean>(false);
  popupState = this.popupStateSource.asObservable();

  private showFloatingButtonSource = new BehaviorSubject<boolean>(true);
  showFloatingButton = this.showFloatingButtonSource.asObservable();

  constructor() { }

  setShowFloatingButton(show: boolean) {
    this.showFloatingButtonSource.next(show);
  }

  togglePopup(state: boolean): void {
    this.popupStateSource.next(state);
    var element = document.querySelector('.modal') as HTMLElement;
    if (this.popupStateSource.value) {
      element.style.display = 'block';
    } else {
      element.style.display = 'none';
    }
  }
}